import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ExternalSystemsService } from './external-systems.abstract.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ExternalSystemsImplService implements ExternalSystemsService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    getConfiguredConnectors(orgTag: string): Observable<any> {
        let headers = new HttpHeaders().set('x-organisation', orgTag);
        return this.http.get(`${this.baseUrl}/configurations/organisation/connectors`, { headers: headers }).pipe(map((response: any) => response));
    }

    getExternalSystemLookup(connectorTag: string, userId: string, orgTag: string): Observable<any> {
        let headers = new HttpHeaders().set('x-organisation', orgTag);
        return this.http.get(`${this.baseUrl}/connector-gateway/lookup/${connectorTag}/${userId}`, { headers: headers }).pipe(map((response: any) => response));
    }
}

export const EXTERNAL_SYSTEMS_SERVICE_PROVIDER = {
    provide: ExternalSystemsService,
    useClass: ExternalSystemsImplService,
};
